import React from "react";

const ClockAudio = () => {
  return (
    <audio id="backgroundMusic" autoPlay>
      <source src="/assets/sounds/Clock.mp3" type="audio/mp3" />
    </audio>
  );
};

export default ClockAudio;
